import { useEffect } from 'react';

import { useTranslation } from 'react-i18next';

import './CheckEmail.scss';
import Logo2 from '../../../components/Logo/Logo2';

const data = {
    en: {
        title: "Error – Something went wrong",
    },
    fr: {
        title: "Erreur – Un problème est survenu",
    },
    de: {
        title: "Fehler – Etwas ist schiefgelaufen",
    },
    hi: {
        title: "त्रुटि – कुछ गलत हो गया",
    },
    id: {
        title: "Error – Terjadi kesalahan",
    },
    it: {
        title: "Errore – Si è verificato un problema",
    },
    ja: {
        title: "エラー – 問題が発生しました",
    },
    ko: {
        title: "오류 – 문제가 발생しました",
    },
    pl: {
        title: "Błąd – Coś poszło nie tak",
    },
    'pt-BR': {
        title: "Erro – Algo deu errado",
    },
    'zh-CN': {
        title: "错误 – 出现了一些问题",
    },
    es: {
        title: "Error – Algo salió mal",
    },
    th: {
        title: "ข้อผิดพลาด – เกิดข้อขัดข้องขึ้น",
    },
    'zh-TW': {
        title: "錯誤 – 發生了一些問題",
    },
    tr: {
        title: "Hata – Bir şeyler ters gitti",
    },
    vi: {
        title: "Lỗi – Đã xảy ra sự cố",
    },
};

const PageError = () => {
    const { t, i18n } = useTranslation();

    useEffect(() => {
        const title = data[i18n.language || 'en'].title;
        document.title = title || data.en.title;
    }, [i18n.language]);

    return (
        <div className="check-email-box">
            <Logo2 />
            <div className='check-email'>
                <div className="check-email-title not-found" style={{ fontSize: '40px' }}>{t('pages.error.title')}</div>
                <div className='check-email-text-wrap'>
                    <p className="check-email-text verified">{t('pages.error.something_wrong')}</p>
                </div>
                <a href="/" className="check-email-action not-found">
                    <span>{t('pages.error.back_home')}</span>
                </a>
            </div>
        </div >
    );
};

export default PageError;
